import script from "./AddAttendance.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAttendance.vue?vue&type=script&setup=true&lang=js"

import "./AddAttendance.vue?vue&type=style&index=0&id=2dffaec0&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dffaec0"]])

export default __exports__